import React from 'react';
import { Provider, ProviderProps } from 'react-redux';
import { ConnectedRouter, ConnectedRouterProps } from 'connected-react-router';
import { renderRoutes } from 'react-router-config';
import { I18nFonts } from 'client/i18n/I18nFonts';
import { Title } from '../../withTitle';
import { AppProviders } from '../../contexts/index';
import { getRoutesWithStore } from '../../routes';

import '@spotify-internal/encore-web/css/encore-anchor-light-theme.css';

type AppEntryProps = {
  store: ProviderProps['store'];
  history: ConnectedRouterProps<any>['history'];
};

const AppEntry = ({ store, history }: AppEntryProps) => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <AppProviders>
        <I18nFonts />
        <Title />
        {renderRoutes(getRoutesWithStore(store) as any)}
      </AppProviders>
    </ConnectedRouter>
  </Provider>
);

export { AppEntry };
